<template>
  <!-- Loading Spinner -->
  <div
    v-if="isLoading"
    class="fixed inset-0 z-50 flex items-center justify-center pointer-events-none"
  >
    <LoadingSpinner
      class="rounded-lg bg-white p-3.5 border-solid border-neutral-300 border shadow-lg pointer-events-auto"
    />
  </div>
  <div class="select-none">
    <!-- Button bar-->
    <div class="flex items-center justify-center mb-1.5 w-full mx-auto space-x-1.5">
        <!-- Calendar View Button -->
        <button
          @click="setView('calendar')"
          class="flex items-center sm:space-x-2 p-2 sm:pr-3 sm:w-28 h-[40px] w-full rounded-lg justify-center text-sm shadow-md"
          :disabled="currentView === 'calendar'"
          :class="{
            'text-white bg-neutral-800 border border-solid border-neutral-800': currentView === 'calendar',
            'text-neutral-800 bg-white hover:bg-neutral-100 border border-solid border-neutral-300': currentView !== 'calendar',
          }"
        >
          <Calendar :size="18" class="-mt-0.5" :stroke-width="1.75" />
          <span class="hidden text-sm font-medium sm:inline">Kalender</span>
        </button>

        <!-- Balance View Button -->
        <button
          @click="setView('balance')"
          class="flex items-center sm:space-x-2 p-2 sm:pr-3 sm:w-28 h-[40px] w-full rounded-lg justify-center text-sm shadow-md"
          :disabled="currentView === 'balance'"
          :class="{
            'text-white bg-neutral-800 border border-solid border-neutral-800': currentView === 'balance',
            'text-neutral-800 bg-white hover:bg-neutral-100 border border-solid border-neutral-300': currentView !== 'balance',
          }"
        >
          <SquareChartGantt :size="18" :stroke-width="1.75" />
          <span class="hidden text-sm font-medium sm:inline">Optælling</span>
        </button>

        <!-- History View Button -->
        <button
          @click="setView('history')"
          class="flex items-center sm:space-x-2 p-2 sm:pr-3 sm:w-28 h-[40px] w-full rounded-lg justify-center text-sm shadow-md"
          :disabled="currentView === 'history'"
          :class="{
            'text-white bg-neutral-800 border border-solid border-neutral-800': currentView === 'history',
            'text-neutral-800 bg-white hover:bg-neutral-100 border border-solid border-neutral-300': currentView !== 'history',
          }"
        >
          <History :size="18" :stroke-width="1.75" />
          <span class="hidden text-sm font-medium sm:inline">Historik</span>
        </button>
    </div>

    <!-- View Component -->
    <div
      :class="{ 'pointer-events-none animate-pulse': isLoading }"
      class="w-full h-full"
    >
      <div class="h-full" ref="viewContainer">
        <AdminCalendar v-if="currentView === 'calendar'" :users="users" />
        <AdminBalance v-if="currentView === 'balance'" :users="users" />
        <AdminHistory v-if="currentView === 'history'" :users="users" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, inject, onMounted, onUnmounted } from "vue";
import { storeToRefs } from "pinia";
import AdminCalendar from "@/components/pages/AdminDashboard/AdminCalendar.vue";
import AdminBalance from "@/components/pages/AdminDashboard/AdminBalance.vue";
import AdminHistory from "@/components/pages/AdminDashboard/AdminHistory.vue";
import LoadingSpinner from "@/components/ui/LoadingSpinner.vue";
import { Calendar, SquareChartGantt, History } from "lucide-vue-next";

// Store injections and refs
const usersStore = inject("usersStore");
const { users, isLoading } = storeToRefs(usersStore);

// View state
const currentView = ref('calendar');

function setView(view) {
  currentView.value = view;
}

// Lifecycle hooks
onMounted(async () => {
  await usersStore.initializeStore();
});

onUnmounted(() => {
  usersStore.stopAutoUpdate();
});
</script>